import "core-js/modules/es.array.push.js";
import Cookie from 'js-cookie';
import { mapState } from 'vuex';
import { audioContextObj } from '@/assets/js/audioContext';
import { addTabTitle, handleLocalStorage, removeDuplicateSegments, routerJump, getTheme, setTheme } from '@/assets/js/utils.js';
import { judgeCanControl, showDeviceTips } from '@/assets/js/attendUser.js';
import newAgoraClient from '@/assets/js/newRtcClient.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      hasStartMicTest: false,
      deviceId: '',
      applicationName: handleLocalStorage('get', 'applicationName'),
      fontVersion: '',
      backendVersion: '',
      splitEmail: '',
      testMicVisible: false,
      rtc: null,
      devicesInfo: {},
      camera: true,
      mic: true,
      speaker: true,
      partyName: '',
      oldPartyName: '',
      //  用来判断是否需要调用更新 title 的接口
      nickName: '',
      passCode: '',
      partyCode: '',
      checkInfo: {},
      commonPartyInfo: {},
      setInfo: {
        speaker: false,
        camera: false,
        mic: false,
        useCamera: false
      },
      organization: '',
      updateTitleUrl: {
        0: '/partyline-backend/commonParty/updateTitle',
        1: '/partyline-backend/group/updateTitle',
        2: '/partyline-backend/conference/updateTitle',
        13: '/partyline-backend/kiosk/updateTitle'
      },
      Parser: require('@/assets/js/us.js'),
      isWindows: true,
      isMac: false,
      openAnywhereTimer: null,
      ontouch: 'ontouchend' in document,
      logoSvg: '',
      cameraName: '',
      showInitMessage: false,
      notNeedVideoTextMap: {
        1: 'Gallery view',
        13: 'Kiosk',
        18: 'Station'
      },
      slotNum: 0,
      testAudioTrack: null
    };
  },
  setup() {
    const {
      isDark
    } = getTheme();
    return {
      isDark,
      getTheme,
      setTheme,
      showDeviceTips
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      userInfo: state => state.loginInfo
    }),
    showNotNeedVideoBox() {
      const channelMoel = this.checkInfo.channelModel;
      return this.checkInfo.owner && (channelMoel == 1 || channelMoel == 13 || this.checkInfo.channelModel == 19) || this.checkInfo.channelModel == 18;
    },
    showNotNeedVideoText() {
      return this.$t('partyInfo.notNeedVideo', {
        partyModule: this.notNeedVideoTextMap[this.checkInfo.channelModel]
      });
    },
    returnPartyID() {
      if (!this.partyCode) return;
      return this.$t('partyInfo.partyID') + ':  ' + this.$options.filters.returnStrByInfo(this.partyCode, this.partyCode.length === 9 ? 3 : 4);
    },
    showPartyName() {
      const info = this.commonPartyInfo;
      if (info && info.partyName) return info.partyName;
      if (info && (info.startPartyTime || info.createTime)) {
        return new Date(info.startPartyTime || info.createTime).toLocaleDateString() + '   ' + new Date(info.startPartyTime || info.createTime).toLocaleTimeString();
      } else {
        return '';
      }
    },
    showNickNameInput() {
      let flag = false;
      if (this.checkInfo.owner) {
        if (this.State.channelModeByRouteName[this.checkInfo.channelModel] === 'party' || this.State.channelModeByRouteName[this.checkInfo.channelModel] === 'coordinator') {
          flag = true;
        }
      } else {
        flag = true;
      }
      return flag;
    },
    cameraOn() {
      let cameraOn = true;
      if (this.checkInfo.owner) {
        // 特殊处理 gallery view 和 kiosk
        if (this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13 || this.checkInfo.channelModel == 18 || this.checkInfo.channelModel == 19) {
          cameraOn = false;
          this.camera = false;
        } else {
          if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
            cameraOn = false;
          }
        }
      } else {
        if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
          cameraOn = false;
        }
        if (this.checkInfo.channelModel == 18) {
          cameraOn = false;
        }
      }
      return cameraOn;
    },
    cameraOff() {
      let cameraOff = false;
      const channelModel = this.checkInfo.channelModel;
      if (this.checkInfo.owner) {
        if (channelModel == 1 || channelModel == 13 || channelModel == 18 || channelModel == 19) {
          cameraOff = true;
        } else {
          if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
            cameraOff = true;
          }
        }
      } else {
        if (channelModel == 18) {
          cameraOff = true;
        }
        if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
          cameraOff = true;
        }
      }
      return cameraOff;
    },
    cameraOffClass() {
      let _class = '';
      if (this.checkInfo.owner && (this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13 || this.checkInfo.channelModel == 19)) _class = 'disabled';
      return _class;
    }
  },
  async created() {
    document.title = this.$t('common.partylinePreviewInit');
    const URL = nodeUrl.parse(location.href, true);
    const idRaw = URL.query.id ? URL.query.id.replace(/[^0-9]/ig, '') : '';
    const join_idRaw = URL.query.join_id ? URL.query.join_id.replace(/[^0-9]/ig, '') : '';
    // 检查各种长度的重复情况
    const id = [18, 24, 32].includes(idRaw.length) ? removeDuplicateSegments(idRaw, idRaw.length) : idRaw;
    const join_id = [18, 24, 32].includes(join_idRaw.length) ? removeDuplicateSegments(join_idRaw, join_idRaw.length) : join_idRaw;
    this.partyCode = id || join_id || '';
    this.slotNum = URL.query.slotNum;
    this.rtc = new newAgoraClient();
    this.addRtcEventListener();

    // 获取前端版本号
    let fontEndVersionStr = handleLocalStorage('get', 'partylineVersion');
    if (fontEndVersionStr && fontEndVersionStr.includes('_')) {
      fontEndVersionStr = fontEndVersionStr.substring(0, fontEndVersionStr.indexOf('_'));
    }
    this.fontVersion = fontEndVersionStr;
    // 获取后台版本号
    this.getBackendVersion();
    const parserObj = this.Parser && new this.Parser();
    this.isMac = parserObj && parserObj.getOS().name === 'Mac OS';
    this.isWindows = parserObj && parserObj.getOS().name === 'Windows';
  },
  async mounted() {
    document.addEventListener('keyup', event => {
      if (event.keyCode === 13) {
        this.jumpPage();
      }
    });
    this.logoSvg = `#${this.State.commonLogo}`;
    await this.checkIsHost();
    if (!this.checkInfo.enable) return;
    this.devicesInfo = await this.rtc.getDevice();
    if (!handleLocalStorage('get', 'speakerId')) {
      handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
    }
    this.deviceId = this.devicesInfo.microphoneId;
    if (!this.checkInfo.owner || this.checkInfo.owner && this.checkInfo.channelModel != 1 && this.checkInfo.channelModel != 13 && this.checkInfo.channelModel != 19) {
      if (this.devicesInfo.cameraId) {
        try {
          this.devicesInfo && this.devicesInfo.cameraList.forEach(item => {
            if (item.deviceId == this.devicesInfo.cameraId) {
              this.cameraName = item.label;
            }
          });
          if (this.checkInfo.channelModel == 18) return;
          this.State.initCamera = true;
          if (this.rtc) {
            const videoTrack = await this.rtc.createCameraTrack(this.devicesInfo.cameraId);
            if (videoTrack) {
              this.rtc.play(this.rtc._localVideoTrack, {
                mediaType: 'video'
              });
              handleLocalStorage('set', 'cameraId', this.devicesInfo.cameraId);
            }
          }
        } catch (e) {
          this.State.showInitCameraTips = true;
        }
        this.State.initCamera = false;
      }
    }
    if (this.devicesInfo.microphoneId && this.rtc && !this.devicesInfo.microphoneError) {
      // 初始化麦克风声音
      await this.rtc.createMicrophoneTrack(this.devicesInfo.microphoneId);
    }
    if (this.rtc._localAudioTrack) {
      const media = new MediaStream();
      media.addTrack(this.rtc._localAudioTrack._mediaStreamTrack);
      audioContextObj.audioTrack(media, 'volumes');
      setTimeout(() => {
        audioContextObj.resumeAudio('volumes');
      }, 1000);
    }
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleEnterKey);
  },
  methods: {
    addRtcEventListener() {
      if (!this.rtc) return;
      this.rtc.on('cameraChange', this.dealCameraChange);
      this.rtc.on('microphonesChange', this.dealMicrophonesChange);
    },
    dealCameraChange(switchInfo) {
      const {
        result,
        cameraList,
        deviceId
      } = switchInfo;
      this.devicesInfo.cameraList = cameraList;
      if (result === 'success') {
        this.devicesInfo.cameraId = deviceId;
        handleLocalStorage('set', 'cameraId', deviceId);
        this.$message.success(this.$t('common.autoSwitchNewCameraSuccess'));
      } else if (result === 'failed') {
        this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
      }
    },
    dealMicrophonesChange(switchInfo) {
      const {
        result,
        microphoneList,
        deviceId
      } = switchInfo;
      this.devicesInfo.microphoneList = microphoneList;
      if (result === 'successs') {
        this.devicesInfo.microphoneId = deviceId;
        handleLocalStorage('set', 'microphoneId', deviceId);
        this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
      } else if (result === 'failed') {
        this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
      }
    },
    getBackendVersion() {
      this.axios.get('/partyline-backend/publicApi/debug/version').then(res => {
        if (!res) return;
        const {
          errorCode
        } = res.data;
        let {
          result
        } = res.data;
        if (errorCode === '0x0') {
          handleLocalStorage('set', 'backendVersion', result);
          if (result && result.includes('_')) {
            result = result.substring(0, result.indexOf('_'));
          }
          this.backendVersion = result;
        }
      });
    },
    dealAnywhereInstall() {
      routerJump('joinParty', {
        join_id: this.partyCode,
        slotNum: this.slotNum
      });
    },
    changeParticipantLanguage() {
      if (this.$i18n.locale === 'zh' || this.$i18n.locale === 'zh-CN') {
        Cookie.set('userLanguage', 'en', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'en';
        this.State.browserLanguage = 'en';
      } else {
        Cookie.set('userLanguage', 'zh', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'zh';
        this.State.browserLanguage = 'zh';
      }
    },
    // 处理关闭弹窗打开音量柱
    async closedMic() {
      var _this$testAudioTrack;
      this.hasStartMicTest = false;
      (_this$testAudioTrack = this.testAudioTrack) === null || _this$testAudioTrack === void 0 ? void 0 : _this$testAudioTrack.setEnabled(false);
      this.testAudioTrack = null;
      if (this.devicesInfo.microphoneId && this.rtc && !this.devicesInfo.microphoneError) {
        // 初始化麦克风声音
        await this.rtc.createMicrophoneTrack(this.devicesInfo.microphoneId);
      }
      if (this.rtc._localAudioTrack) {
        const media = new MediaStream();
        media.addTrack(this.rtc._localAudioTrack._mediaStreamTrack);
        audioContextObj.audioTrack(media, 'volumes');
        setTimeout(() => {
          audioContextObj.resumeAudio('volumes');
        }, 1000);
      }
    },
    async startTesting() {
      this.hasStartMicTest = !this.hasStartMicTest;
      if (this.hasStartMicTest) {
        this.testAudioTrack = await this.rtc.createMicrophoneTrack(this.deviceId);
        if (this.testAudioTrack) {
          this.testAudioTrack.play();
          const media = new MediaStream();
          media.addTrack(this.testAudioTrack._mediaStreamTrack);
          audioContextObj.audioTrack(media, 'volume');
          setTimeout(() => {
            audioContextObj.resumeAudio('volume');
          }, 1000);
        }
      } else {
        var _this$testAudioTrack2;
        (_this$testAudioTrack2 = this.testAudioTrack) === null || _this$testAudioTrack2 === void 0 ? void 0 : _this$testAudioTrack2.setEnabled(false);
        this.testAudioTrack = null;
      }
    },
    async handleAudio() {
      var _this$testAudioTrack3;
      this.hasStartMicTest = false;
      (_this$testAudioTrack3 = this.testAudioTrack) === null || _this$testAudioTrack3 === void 0 ? void 0 : _this$testAudioTrack3.setEnabled(false);
      this.testAudioTrack = null;
    },
    openTestMic() {
      this.testMicVisible = true;
      // 不显示音量柱
      if (this.rtc._localAudioTrack) this.rtc._localAudioTrack.setEnabled(false);
    },
    async checkIsHost() {
      if (!this.partyCode) return;
      let haveHistoryMem = '';
      if (this.partyCode.length == 16) {
        haveHistoryMem = handleLocalStorage('get', 'galleryMemberId') || 'PL_' + new Date().getTime();
      } else {
        haveHistoryMem = handleLocalStorage('get', 'memberId') || this.State.loginInfo.id || 'PL_' + new Date().getTime();
      }
      const params = {
        partyCode: this.partyCode,
        clientType: 0,
        memberId: haveHistoryMem
      };
      if (this.partyCode.length > 20) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      await this.axios.get('/partyline-backend/party/noLogin/checkV2', {
        params
      }, {
        errorTip: false
      }).then(res => {
        if (!res) return;
        if (res.data && res.data.errorCode === '0x0') {
          var _this$$router;
          const result = res.data.result;
          this.checkInfo = result;
          if (!result.enable) (_this$$router = this.$router) === null || _this$$router === void 0 ? void 0 : _this$$router.push({
            name: 'remove',
            query: {
              type: 'disableParty'
            }
          });
          // 判断是否是commentator的party
          if (result.channelModel == 12 && this.State.config.urlInfo.commentatorParty.includes('/commentator') && this.partyCode) {
            window.location.href = `${this.State.config.urlInfo.commentatorParty}?join_id=${this.partyCode}`;
            return;
          }
          if (!result.commonPartyInfo) return;
          this.commonPartyInfo = result.commonPartyInfo;
          this.nickName = this.commonPartyInfo.nickname;
          if (this.checkInfo.owner && !this.nickName) {
            this.splitEmail = result.userEmail.split('@')[0];
          } else if (this.nickName) {
            this.splitEmail = this.nickName;
          }
          if (this.commonPartyInfo.partyName) {
            this.partyName = this.commonPartyInfo.partyName;
          } else {
            this.partyName = new Date(this.commonPartyInfo.startPartyTime || this.commonPartyInfo.createTime).toLocaleDateString() + '   ' + new Date(this.commonPartyInfo.startPartyTime || this.commonPartyInfo.createTime).toLocaleTimeString();
          }
          addTabTitle({
            userInfo: result.commonPartyInfo,
            useTime: true
          });
          this.oldPartyName = JSON.parse(JSON.stringify(this.partyName));
        }
      }).catch(e => {
        console.log('check interface failed');
      });
    },
    getMediaDeviceStatus() {
      if (!this.partyCode && !this.State.partyCode) return;
      const params = {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode || this.State.partyCode,
        keys: ['nickName', 'tagName', 'talkBack', 'camera', 'mic', 'blockAudio', 'blockVideo', 'voipRid', 'voipSourceId', 'flipVideo'],
        marks: [id]
      };
      this.axios.get('/partyline-backend/behavior/noLogin/getList', {
        params
      }, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    async setCameraOrMic(type) {
      if (type === 'muteVideo') {
        if (!this.camera && (this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13) && this.checkInfo.owner) {
          return;
        }
        const videoTrack = this.rtc._localVideoTrack;
        const canExecute = judgeCanControl('video', this.devicesInfo);
        if (!canExecute) return;
        this.State.initCamera = this.camera;
        this.camera = !this.camera;
        this.camera ? videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.play('local_stream', {
          mirror: true
        }) : videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.stop();
      } else {
        var _this$rtc;
        const audioTrack = (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc._localAudioTrack;
        const canExecute = judgeCanControl('audio', this.devicesInfo);
        if (!canExecute) return;
        this.mic = !this.mic;
        if (!this.mic && this.speaker) {
          audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.setEnabled(false);
        } else if (this.mic && this.speaker && audioTrack) {
          await audioTrack.setEnabled(true);
          const media = new MediaStream();
          media.addTrack(audioTrack._mediaStreamTrack);
          audioContextObj.audioTrack(media, 'volumes');
          setTimeout(() => {
            audioContextObj.resumeAudio('volumes');
          }, 1000);
        }
      }
    },
    async changeDevice(val) {
      if ((this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13) && this.checkInfo.owner) {
        return;
      }
      if (!this.rtc) return;
      if (val.type === 'video') {
        this.showInitMessage = true;
        this.State.initCamera = true;
        this.State.showInitCameraTips = false;
        if (this.rtc._localVideoTrack) {
          this.rtc.setDevice(val.deviceId, 'video', result => {
            if (result === 'failed') {
              this.$message.warning({
                message: this.$t('common.switchFailed'),
                type: 'warning',
                offset: 50,
                showClose: true
              });
            } else {
              this.devicesInfo.cameraId = val.deviceId;
            }
            this.showInitMessage = false;
            this.State.initCamera = false;
          });
        } else {
          await this.rtc.createCameraTrack(val.deviceId);
          if (this.rtc._localVideoTrack) {
            this.devicesInfo.cameraId = val.deviceId;
            this.rtc.play(this.rtc._localVideoTrack, {
              mediaType: 'video'
            });
            handleLocalStorage('set', 'cameraId', val.deviceId);
          } else {
            this.devicesInfo && this.devicesInfo.cameraList.forEach(item => {
              if (item.deviceId == val.deviceId) {
                this.cameraName = item.label;
                this.State.showInitCameraTips = true;
              }
            });
          }
          this.showInitMessage = false;
          this.State.initCamera = false;
        }
      } else if (val.type === 'audio') {
        if (this.rtc._localAudioTrack) {
          this.rtc.setDevice(val.deviceId, 'audio', result => {
            if (result === 'success') {
              const media = new MediaStream();
              media.addTrack(this.rtc._localAudioTrack._mediaStreamTrack);
              audioContextObj.audioTrack(media, 'volumes');
              setTimeout(() => {
                audioContextObj.resumeAudio('volumes');
              }, 1000);
            }
          });
        } else {
          await this.rtc.createMicrophoneTrack(val.deviceId);
          if (this.rtc._localAudioTrack) {
            handleLocalStorage('set', 'microphoneId', val.deviceId);
            const media = new MediaStream();
            media.addTrack(this.rtc._localAudioTrack._mediaStreamTrack);
            audioContextObj.audioTrack(media, 'volumes');
            setTimeout(() => {
              audioContextObj.resumeAudio('volumes');
            }, 1000);
          }
        }
      } else {
        handleLocalStorage('set', 'speakerId', val.deviceId);
        this.devicesInfo.speakerId = val.deviceId;
      }
    },
    changeMute() {
      this.speaker = !this.speaker;
    },
    async jumpPage() {
      if (!this.judgeCanJump()) {
        return;
      }
      const saveSuceess = await this.saveNickName();
      if (!saveSuceess) {
        return;
      }
      if (this.partyName && this.partyName != this.oldPartyName) {
        await this.updateTitle();
      }
      const publicPath = this.State.publicPath || 'partyline';
      if (this.checkInfo.channelModel == 18) {
        if (this.State.hasLogin) {
          window.location.href = `${location.origin}/${publicPath}/participate/${this.State.participateChannelMode[this.checkInfo.channelModel]}?model=station&id=${this.partyCode}`;
        } else {
          routerJump('joinOrStart', {
            model: 'station',
            partyCode: this.partyCode
          });
        }
      } else {
        if (this.checkInfo.owner) {
          window.location.href = `${location.origin}/${publicPath}/control/${this.State.channelModeByRouteName[this.checkInfo.channelModel]}?id=${this.partyCode}`;
        } else {
          if (this.slotNum) {
            window.location.href = `${location.origin}/${publicPath}/participate/interviewParticipate?id=${this.partyCode}&slotNum=${this.slotNum}`;
          } else {
            window.location.href = `${location.origin}/${publicPath}/participate/${this.State.participateChannelMode[this.checkInfo.channelModel]}?id=${this.partyCode}`;
          }
        }
      }
    },
    judgeCanJump() {
      let flag = true;
      if (!this.partyCode) {
        this.$message.error(this.$t('partyInfo.noPartyCode'));
        flag = false;
      }
      if (this.checkInfo.owner) {
        if (!this.partyName || (this.checkInfo.channelModel == 0 || this.checkInfo.channelModel == 2) && !this.splitEmail) {
          this.$message.error(this.$t('partyInfo.joinFailed'));
          flag = false;
        }
      } else {
        if (!this.splitEmail && this.checkInfo.channelModel != 1) {
          this.$message.error(this.$t('partyInfo.nameCannotEmpty'));
          flag = false;
        }
      }
      if (!this.checkInfo.enable) {
        flag = false;
        this.$message.error(this.$t('partyInfo.partyDisabled'));
      }
      return flag;
    },
    async saveNickName() {
      this.splitEmail = this.splitEmail || ' ';
      let data = [];
      let flag = true;
      if (this.State.hasVideo && this.camera) {
        this.setInfo.camera = true;
      } else {
        this.setInfo.camera = false;
      }
      if (this.State.hasAudio && this.mic) {
        this.setInfo.mic = true;
      } else {
        this.setInfo.mic = false;
      }
      this.setInfo.speaker = this.speaker;
      this.setInfo.noHaveCamera = !this.State.hasVideo;
      this.setInfo.useCamera = this.State.hasVideo ? '1' : '3';
      data = [{
        mark: '',
        annotation: this.partyCode,
        key: 'nickName',
        value: this.splitEmail,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'speaker',
        value: this.setInfo.speaker,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'camera',
        value: this.setInfo.camera,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'useCamera',
        value: this.setInfo.useCamera,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'mic',
        value: this.setInfo.mic,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'noHaveCamera',
        value: this.setInfo.noHaveCamera,
        notify: true,
        initiator: ''
      }];
      if (this.State.participateChannelMode[this.checkInfo.channelModel] == 'reporter' || this.State.channelModeByRouteName[this.checkInfo.channelModel] == 'coordinator') {
        data.push({
          mark: '',
          annotation: this.partyCode,
          key: 'organization',
          value: this.organization,
          notify: true,
          initiator: ''
        });
      }
      let haveHistoryMem = '';
      // Gallery view 模式memberId特殊
      if (this.checkInfo.channelModel == 1) {
        const id = this.State.loginInfo.id ? this.State.loginInfo.id + '_' + Date.now() : '';
        haveHistoryMem = handleLocalStorage('get', 'galleryMemberId') || id;
      } else {
        // 如果已经登录，但是memberid不是自己，则换掉
        haveHistoryMem = this.State.loginInfo.id || handleLocalStorage('get', 'memberId');
      }
      // 如果未登录，但是 memberid是userid，则换掉
      if (this.checkInfo.channelModel != 1) {
        if (handleLocalStorage('get', 'memberId') && !this.State.hasLogin && !handleLocalStorage('get', 'memberId').startsWith('PL_')) {
          haveHistoryMem = 'PL_' + new Date().getTime();
        }
      }
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 3,
        host: this.checkInfo.owner,
        slotNum: this.slotNum,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'enableControlMedia', 'flipVideo'],
        behaviors: data,
        invitePassCode: this.passCode
      };
      await this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (!res) return;
        if (res.data.errorCode != '0x0') {
          flag = false;
        }
        this.checkInfo.channelModel == 1 ? handleLocalStorage('set', 'galleryMemberId', params.memberId) : handleLocalStorage('set', 'memberId', params.memberId);
      });
      return flag;
    },
    async updateTitle() {
      const params = {
        id: this.checkInfo.commonPartyInfo.id,
        title: this.partyName,
        _partyCode: this.partyCode
      };
      await this.axios.post(this.updateTitleUrl[this.checkInfo.channelModel], params).then(res => {}).catch(err => {
        console.log(err);
      });
    }
  },
  async beforeRouteLeave(to, from, next) {
    next();
  }
};